import { render, staticRenderFns } from "./LandingPageView.vue?vue&type=template&id=9936bd36"
import script from "./LandingPageView.vue?vue&type=script&lang=js"
export * from "./LandingPageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports